module.exports = __webpack_public_path__ + "img/6.2b76225b.png";